<template>
    <b-container fluid>
        <b-row class="">
            <b-col cols="12">
                <div class="border-bottom mb-3 pb-3">
                    <h3>일반기업 관리</h3>
                    <p class="fw-400 text-secondary mb-0">
                        Assessment 평가 및 서비스를 이용하는 기업 정보를 관리합니다.
                    </p>
                </div>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col cols="12">
                <b-card no-body bg-variant="white">
                    <template #header>
                        <div class="d-flex align-items-center justify-content-between">
                            <h5 class="mb-0">기업 검색하기</h5>

                            <div v-show="listLoading">
                                <div class="d-flex align-items-center">
                                    <b-spinner class="mr-2" variant="primary" style="height: 1rem; width: 1rem;"/>
                                    <p class="d-inline-block mb-0">조회중...</p>
                                </div>
                            </div>
                            <div v-show="!listLoading">
                                <b-btn
                                    variant="primary"
                                    :disabled="listLoading"
                                    @click="searchData"
                                >
                                    검색하기
                                </b-btn>
                            </div>
                        </div>
                    </template>

                    <div class="p-3">
                        <b-row>
                            <b-col cols="12" md="6" xl="6" class="mb-3 mb-xl-0">
                                <b-form-group
                                    id="fieldset-input-company-name"
                                    :label="$t('기업명')"
                                    label-for="company-input-company-name"
                                    class="mb-0"
                                >
                                    <b-form-input id="company-input-company-name"
                                                  v-model="searchFormValue.company_name"
                                                  :disabled="listLoading"
                                                  trim
                                                  @keypress.enter="searchData"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6" xl="6" class="mb-3 mb-xl-0">
                                <b-form-group
                                    id="fieldset-input-company-id"
                                    :label="$t('기업ID')"
                                    label-for="company-input-company-id"
                                    class="mb-0"
                                >
                                    <b-form-input id="company-input-company-id"
                                                  v-model="searchFormValue.company_id"
                                                  :disabled="listLoading"
                                                  trim
                                                  @keypress.enter="searchData"
                                    />
                                </b-form-group>
                            </b-col>
                            <!--                            <b-col cols="12" md="6" xl="3" class="mb-3 mb-md-0">-->
                            <!--                                <b-form-group-->
                            <!--                                    id="fieldset-input-company-code"    -->
                            <!--                                    :label="$t('기업 코드')"-->
                            <!--                                    label-for="company-input-company-code"-->
                            <!--                                    class="mb-0"-->
                            <!--                                >-->
                            <!--                                    <b-form-input id="company-input-company-code"-->
                            <!--                                                  v-model="searchFormValue.company_code"-->
                            <!--                                                  :disabled="listLoading"-->
                            <!--                                                  trim-->
                            <!--                                                  @keypress.enter="searchData"-->
                            <!--                                    />-->
                            <!--                                </b-form-group>-->
                            <!--                            </b-col>-->

                            <!--                            <b-col cols="12" md="6" xl="3" class="mb-3 mb-md-0">-->
                            <!--                                <b-form-group-->
                            <!--                                    id="fieldset-input-corporate-code"-->
                            <!--                                    :label="$t('법인 코드')"-->
                            <!--                                    label-for="company-input-corporate-code"-->
                            <!--                                    class="mb-0"-->
                            <!--                                >-->
                            <!--                                    <b-form-input id="company-input-corporate-code"-->
                            <!--                                                  v-model="searchFormValue.corporate_code"-->
                            <!--                                                  :disabled="listLoading"-->
                            <!--                                                  trim-->
                            <!--                                                  @keypress.enter="searchData"-->
                            <!--                                    />-->
                            <!--                                </b-form-group>-->
                            <!--                            </b-col>-->
                        </b-row>
                    </div>
                </b-card>


                <b-row class="mt-3">
                    <b-col cols="12">
                        <b-card
                            :class="[{ 'shadow-sm': searchResults || (!listLoading && searchResults) }, 'list-container', 'column-wrapped']"
                            :bg-variant="!searchResults ? 'light' : 'white'"
                            no-body
                        >
                            <template #header>
                                <div class="d-flex align-items-center justify-content-between">
                                    <div>
                                        <h6 class="mb-0">기업 목록</h6>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <b-button size="md"
                                                  @click="openCompanyModal('add')">기업 등록
                                        </b-button>

                                    </div>
                                </div>
                            </template>
                            <div class="table-container">
                                <b-table
                                    fixed responsive
                                    :items="searchResults"
                                    :fields="tableColumns"
                                    class="mb-0"
                                    :empty-html="getEmptyTableHTML"
                                    show-empty
                                    :busy="listLoading"
                                >
                                    <template #cell(company_name)="row">
                                        <span v-b-tooltip.hover="get_tooltip_title(row.value)">{{ row.value }}</span>
                                    </template>

                                    <template #cell(id)="row">
                                        <span v-b-tooltip.hover="get_tooltip_title(row.value)">{{ row.value }}</span>
                                    </template>

                                    <template #cell(company_code)="row">
                                        <span v-b-tooltip.hover="get_tooltip_title(row.value)">{{ row.value }}</span>
                                    </template>
                                    <template #cell(country)="row">
                                        <span v-b-tooltip.hover="get_tooltip_title(row.value)">{{ row.value }}</span>
                                    </template>


                                    <template #cell(detail)="data">
                                        <b-btn size="sm"
                                               variant="outline-primary"
                                               @click="(ev) => openCompanyModal('detail',data.item.id, ev)">
                                            {{ $t('상세') }}
                                        </b-btn>
                                    </template>
                                </b-table>
                                <div class="pagination-container">
                                    <b-pagination
                                        v-model="pagination.currentPage"
                                        :total-rows="pagination.totalRows"
                                        :per-page="pagination.perPage"
                                        first-number last-number
                                        :disabled="listLoading"
                                        align="fill"
                                        @change="(page)=>changeQuery({page})"
                                    ></b-pagination>
                                    <b-form-select
                                        v-model="pagination.perPage"
                                        class="ml-3" style="width: 100px"
                                        :disabled="listLoading"
                                        @change="(pageSize)=>changeQuery({pageSize})"
                                    >
                                        <b-form-select-option v-for="opt in perPageOptions"
                                            :key="opt.value" :value="opt.value">{{ opt.text }}
                                        </b-form-select-option>
                                    </b-form-select>
                                </div>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <CompanyModal ref="companyModal"
                      :detailId="selectedCompanyId"
                      @updateDetailData="updateDetailData"
        />
    </b-container>
</template>

<script>
import {
    getDefaultPagination,
    getEmptyTableHTML,
} from '@shared/components/admin/pages/Management/common-data';
import {companyColumns} from '@shared/components/admin/pages/Management/Company/data';
import CompanyModal from '@shared/components/admin/pages/Management/Company/CompanyModal.vue';
import PaginationPageMixin from '@shared/mixin/pagination-page-mixins';

const searchFormValue = {
    company_name: null,
    company_id: null,
};

export default {
    name: 'CompanyManagement',
    components: {CompanyModal},
    mixins: [PaginationPageMixin({
        searchForm: searchFormValue,
        pagination: getDefaultPagination(1, 20)
    })],
    data() {
        return {
            selectedCompanyId: null,
        };
    },
    computed: {
        tableColumns() {
            return companyColumns.map(column => ({
                ...column,
                label: this.$t(column.label)
            }));
        },
        getEmptyTableHTML() {
            return getEmptyTableHTML('조회된 기업이 없습니다.');
        },
    },
    watch: {
        '$route': {
            handler() {
                this.setSearchDataFormQuery();
                this.fetchData();
            }
        }
    },
    mounted() {
        this.setSearchDataFormQuery();
        this.fetchData();
    },
    methods: {
        async searchData() {
            this.pagination.currentPage = 1;
            const checkSameQuery = await this.changeQuery({});
            if (checkSameQuery) {
                await this.fetchData();
            }
        },
        async fetchData() {
            try {
                this.listLoading = true;
                const params = {
                    page: this.pagination.currentPage,
                    per_page: this.pagination.perPage,
                };
                if (this.searchFormValue.company_name) {
                    params.search_keyword = this.searchFormValue.company_name;
                }
                if (this.searchFormValue.company_id) {
                    params.company_id = this.searchFormValue.company_id;
                }

                const res = await this.$axios.get('/admin/company', { params });
                // admin endpoint uses jsonify() directly — res.data (NOT res.data.data)
                const { companies, total } = res.data;
                this.searchResults = companies;
                this.pagination.totalRows = total;
            } catch (error) {
                console.error(error);
                this.$EventBus.$emit('toast-failure', this.$t('기업 검색 오류'),
                    '기업 목록 조회 도중 오류가 발생했습니다.');
            } finally {
                this.listLoading = false;
            }
        },
        async selectCompany(company_id) {
            try {
                const _res_company_info = await this.$axios.get(`/admin/company/${company_id}/info`);
                const {company, member, projects} = _res_company_info.data;
                const {company_name, company_code, company_address, company_tel, client} = company;

                this.selected_company = {
                    company_id, company_name, company_code, company_address, company_tel, client,
                    member, projects
                };
            } catch (error) {
                this.$EventBus.$emit('toast-failure', this.$t('기업 선택'), '기업 선택 후 처리 중 장애가 발생했습니다. 개발팀에 문의해주세요.');
            }
        },
        async openCompanyModal(mode, id, ev) {
            if(mode === 'add'){
                this.$refs.companyModal.changeMode(mode);
                this.$bvModal.show('company-detail-modal');
                return;
            }
            this.selectedCompanyId = id;

            if(ev.altKey){
                this.$refs.companyModal.changeMode(mode);
                this.$bvModal.show('company-detail-modal');
                return;
            }
            if(ev.ctrlKey){
                window.open(`/admin/company/${id}`, '_blank');
                return;
            }

            this.$router.push(`/admin/company/${id}`).catch(e => {
                console.error(e);
            });
        },
        updateDetailData(updatedUser) {
            const idx = this.searchResults.findIndex((item) => {
                return item.id === updatedUser.id;
            });
            this.$set(this.searchResults, idx, updatedUser);
            this.selectedUser = updatedUser;
        }
    }
};
</script>

<style scoped>
.pagination-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 16px;
    border-top: 1px solid #e9ecef;
}

.pagination-container ::v-deep .pagination {
    margin-bottom: 0;
    gap: 4px;
}

.pagination-container ::v-deep .page-link {
    min-width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    color: #495057;
    border: 1px solid #dee2e6;
    transition: all 0.15s ease;
}

.pagination-container ::v-deep .page-link:hover {
    background-color: #e9ecef;
    border-color: #dee2e6;
    color: #212529;
}

.pagination-container ::v-deep .page-item.active .page-link {
    background-color: #007bff;
    border-color: #007bff;
    color: #fff;
    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}

.pagination-container ::v-deep .page-item.disabled .page-link {
    color: #adb5bd;
    border-color: #e9ecef;
    background-color: #fff;
}
</style>
